import { Colors } from "../../../utils/colors";
import GreyTennisLogo from "../../../assets/tennis_grey_bg.png";
import { formatDateTime } from "../../../utils/utils";
import { useMemo } from "react";
import { TCText } from "../../../components/tcText/TCText";

type props = {
  matchDate?: string;
  courtName?: string;
};
export const MatchCardHeader: React.FC<props> = ({ matchDate, courtName }) => {
  const dateTime = useMemo(
    () => (matchDate ? formatDateTime(matchDate) : "-"),
    [matchDate]
  );
  return (
    <div
      style={{
        width: "100%",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 8,
        paddingBottom: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img
          src={GreyTennisLogo}
          alt=""
          style={{
            width: 32,
            height: 32,
            objectFit: "cover", // Ensures the image covers the area
          }}
        />
        {courtName ? (
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <TCText
              value={courtName}
              style={{ fontSize: 14, fontWeight: 600, color: Colors.grey }}
            />
          </div>
        ) : (
          <TCText
            value="Match"
            style={{ fontSize: 14, fontWeight: 600, color: Colors.grey }}
          />
        )}
      </div>
      {/* {showVideoIndicator && (
        <img
          src={WhiteVideo}
          alt=""
          style={{
            width: 16,
            height: 16,
            objectFit: "contain", // Ensures the image covers the area
          }}
        />
      )} */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <TCText
          value={dateTime.includes(",") ? dateTime.split(",")[0] : ""}
          style={{ fontSize: 14, fontWeight: 600, color: Colors.grey }}
        />
        <div style={{ height: 15, width: 1, backgroundColor: Colors.grey }} />
        <TCText
          value={dateTime.includes(",") ? dateTime.split(",")[1] : ""}
          style={{ fontSize: 14, fontWeight: 600, color: Colors.grey }}
        />
      </div>
    </div>
  );
};
